import {
    BAGGAGE_BATCH_RECEIVED, BAGGAGE_FILTER_SELECTED, CLEAR_FILTER, PARENT_FILTERS_CHANGED, RESET_ALL_FILTERS,
    SET_SELECTED_URL_FILTERS
} from "../../actions/FlightsActions";

export const initialState = {
    freeBaggage: false,
    selected: {
        included: true,
        excluded: true
    }
};

const BaggageFilterReducer = (state = initialState, action) => {
    switch (action.type) {
        case BAGGAGE_BATCH_RECEIVED:
            return {
                ...state, freeBaggage: action.payload
            };
        case BAGGAGE_FILTER_SELECTED:
            if (action.payload === 'include') {
                return {...state, selected: {...state.selected, included: !state.selected.included}}
            }

            if (action.payload === 'exclude') {
                return {...state, selected: {...state.selected, excluded: !state.selected.excluded}}
            }

            return state;
        case SET_SELECTED_URL_FILTERS:
            if (action.name === 'baggage') {
                return {
                    ...state,
                    selected: {included: action.payload.included, excluded: action.payload.excluded},
                };
            }

            return state;
        case PARENT_FILTERS_CHANGED:
            return {...state, selected: action.filters.baggage.selected};
        case CLEAR_FILTER:
            if (action.filter === 'baggage') {
                return {...state, selected: initialState.selected};
            }

            return state;
        case RESET_ALL_FILTERS:
            return {...state, selected: initialState.selected};
        default:
            return state
    }
};

export default BaggageFilterReducer;



// WEBPACK FOOTER //
// ./src/reducers/filters/BaggageFilterReducer.js